// src/components/calendar/eventModal.js

import { useEffect } from "react";

export default function EventModal({ selectedEvent, isOpen, onClose, formatDateTime }) {

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen || !selectedEvent) return null;

  const {
    event_type,
    title,
    start,
    primary_technician,
    additional_technicians,
    job_number,
    property,
    address_line,
    city,
    state,
    zipcode,
    employee_name
  } = selectedEvent;

  const eventLabels = {
    work: "Work",
    travel: "Travel",
    office: "Office",
    rest: "Rest",
    training: "Training",
    no_job: "No Job",
    event: "Event",
    holiday: "Holiday",
    birthday: "Birthday"
  };

  const label = eventLabels[event_type] || "Event";

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 animate-scaleIn"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Header */}
        <div className="flex justify-between items-start mb-5">

          <div>
            {event_type === "birthday" ? (
              <h2 className="text-2xl font-bold">
                {employee_name}'s Birthday
              </h2>
            ) : (
              <>
                <p className="text-xs uppercase tracking-wide text-gray-500">
                  {label}
                </p>
                <h2 className="text-2xl font-semibold">
                  {title}
                </h2>
              </>
            )}
          </div>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 text-lg"
          >
            ×
          </button>

        </div>

        {/* Event Content */}
        {event_type === "holiday" && (
          <p className="text-gray-600">Holiday</p>
        )}

        {["event","travel","office","rest","training","no_job"].includes(event_type) && (
          <div className="space-y-2 text-sm">
          </div>
        )}

        {event_type === "work" && (
          <div className="space-y-4 text-sm">

            {/* Job Details */}
            <div className="grid grid-cols-2 gap-2">

              <p className="font-semibold">Job Number</p>
              <p>{job_number || "-"}</p>

              <p className="font-semibold">Date</p>
              <p>{formatDateTime(start)}</p>

              <p className="font-semibold">Primary Technician</p>
              <p>{primary_technician || "-"}</p>

              <p className="font-semibold">Additional Technicians</p>
              <p>{additional_technicians || "-"}</p>

            </div>

            {/* Property */}
            <div className="border-t pt-3">

              <p className="font-semibold">Property</p>

              <p>{property || "-"}</p>

              <p className="text-gray-600">
                {address_line}, {city}, {state} {zipcode}
              </p>

            </div>

          </div>
        )}

        {/* Footer */}

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
}